import { useEffect, useRef } from "react";
import { useVisitorTracking } from "@/hooks/useVisitorTracking";

// Component to initialize visitor tracking on app load - runs once
const VisitorTracker = () => {
  const initialized = useRef(false);
  
  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;
  }, []);

  // Only mount the hook once via the ref guard above
  useVisitorTracking();
  
  return null;
};

export default VisitorTracker;
